import { render, staticRenderFns } from "./app-icon.vue?vue&type=template&id=767f4149"
import script from "./app-icon.vue?vue&type=script&lang=js"
export * from "./app-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports